
import React from 'react';
import ConfirmationDialog from '@/components/interview/ConfirmationDialog';

interface ConfirmationDialogsProps {
  isPublishConfirmOpen: boolean;
  isDeleteConfirmOpen: boolean;
  setIsPublishConfirmOpen: (isOpen: boolean) => void;
  setIsDeleteConfirmOpen: (isOpen: boolean) => void;
  handleConfirmedPublish: () => Promise<void>;
  handleConfirmedDelete: () => Promise<void>;
}

const ConfirmationDialogs: React.FC<ConfirmationDialogsProps> = ({
  isPublishConfirmOpen,
  isDeleteConfirmOpen,
  setIsPublishConfirmOpen,
  setIsDeleteConfirmOpen,
  handleConfirmedPublish,
  handleConfirmedDelete,
}) => {
  return (
    <>
      <ConfirmationDialog
        isOpen={isPublishConfirmOpen}
        onClose={() => setIsPublishConfirmOpen(false)}
        onConfirm={handleConfirmedPublish}
        title="Publiser intervju"
        description="Er du sikker på at du vil publisere dette intervjuet?"
        confirmText="Bekreft"
        cancelText="Kanseller"
      />
      
      <ConfirmationDialog
        isOpen={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmedDelete}
        title="Slett intervju"
        description="Er du sikker på at du vil slette dette intervjuet? Denne handlingen kan ikke angres."
        confirmText="Slett"
        cancelText="Kanseller"
      />
    </>
  );
};

export default ConfirmationDialogs;
